// extracted by mini-css-extract-plugin
module.exports = {"facilityCard":"FacilityPage_facilityCard___rBv9","facilityImageSection":"FacilityPage_facilityImageSection__FklPN","facilityTitle":"FacilityPage_facilityTitle__Q__38"};